import React from "react";
import './chevrons.css';

export default {
  left: (showChevron) => (
    <svg viewBox="0 0 614 1024" width="3rem" height="4rem">
      <path
        className={`chevron chevron_left ${showChevron ? "hoverChevron" : ""}`}
        d="M508.201-2.299c-8.907 0.365-16.581 3.928-24.027 11.237l-8.77 8.588-459.756 459.711c-8.588 8.633-13.338 20.099-13.338 32.295s4.751 23.662 13.338 32.295l468.709 468.572c7.491 7.354 15.165 10.917 24.21 11.283 7.902 0.32 20.007-7.035 33.117-20.144 8.542-8.588 16.81-17.632 24.529-26.95 1.919-2.33 3.563-4.431 5.070-6.349l-22.657-22.611-436.049-436.095 458.386-458.386c-1.507-1.919-3.198-4.065-5.116-6.395-7.674-9.273-15.942-18.317-24.484-26.859-13.11-13.155-25.215-20.51-33.163-20.19z"
      />
    </svg>
  ),
  right: (showChevron) => (
    <svg viewBox="0 0 614 1024" width="3rem" height="4rem">
      <path
        className={`chevron chevron_right ${showChevron ? "hoverChevron" : ""}`}
        d="M65.391 1021.681c8.907-0.365 16.581-3.928 24.027-11.237l8.77-8.588 459.756-459.711c8.588-8.633 13.338-20.099 13.338-32.295s-4.751-23.662-13.338-32.295l-468.709-468.572c-7.491-7.354-15.165-10.917-24.21-11.283-7.902-0.32-20.007 7.035-33.117 20.144-8.542 8.588-16.81 17.632-24.529 26.95-1.919 2.33-3.563 4.431-5.070 6.349l22.657 22.611 436.049 436.095-458.386 458.386c1.507 1.919 3.198 4.065 5.116 6.395 7.674 9.273 15.942 18.317 24.484 26.859 13.11 13.155 25.215 20.51 33.163 20.19z"
      />
    </svg>
  )
};
